// extracted by mini-css-extract-plugin
module.exports = {"container":"FormTel_container__3ZM9v","phone-area":"FormTel_phone-area__20s2e","tel-item":"FormTel_tel-item__41_XD"};